// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__FGOcP"};